import { Pagination } from 'rsuite'

//
// The pager under a paged list.
//
// Operator, 13.10.2026: lists show ten rows a page and get a pager. The
// sidebars loaded one page and had none — the eleventh user or project was
// out of reach, in the "Open project" dialog as well.
//

/** Rows per page in the paged lists (users, projects, tenants). */
export const LIST_PAGE_SIZE = 10

type ListPagerProps = {
    total: number
    page: number
    onChangePage: (page: number) => void
    disabled?: boolean
}

/** Nothing to turn over, nothing shown. */
export default function ListPager({ total, page, onChangePage, disabled }: ListPagerProps) {
    if (!total || total <= LIST_PAGE_SIZE) return null
    return (
        <Pagination
            className="list-pager"
            prev
            next
            size="xs"
            maxButtons={5}
            total={total}
            limit={LIST_PAGE_SIZE}
            activePage={page}
            disabled={disabled}
            onChangePage={onChangePage}
            layout={['pager']}
        />
    )
}
